// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileRowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '6px 0',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  descText: {
    flex: 1,
    margin: 0,
    textTransform: 'uppercase',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
    fontWeight: 600,
    textAlign: 'center',

    [theme.breakpoints.down(500)]: {
      flex: 'none',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  text: {
    flex: 1,
    margin: '8px 0 0',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontWeight: 600,
    textAlign: 'center',

    [theme.breakpoints.down(500)]: {
      flex: 'none',
      margin: 0,
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  arrowRight: {
    width: 8,
  },
  buttonContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '2px 10px',

    '&:focus': {
      outline: 'none',
    },
  }
});

export default styles;
